"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdgeBase = void 0;
class EdgeBase {
}
exports.EdgeBase = EdgeBase;
